// extracted by mini-css-extract-plugin
module.exports = {"messageText":"PurchaseTokensMessage_messageText__womZn","purchaseButton":"PurchaseTokensMessage_purchaseButton___IdXW"};